/* Favourites (explicit request 2026-09-23, "crear la función de añadir a favoritos").
   Hearts: every [data-product-wishlist] button (product page title, product cards) toggles its data-handle in
   localStorage ("liorme_wishlist", a list of product handles) and shows filled when saved.
   Header heart ([data-js-wishlist-button]) turns solid while something is saved and opens the favourites panel
   (snippets/wishlist-drawer.liquid); "Wishlist" in the drawer menu clicks that same header heart.
   Panel: one row per saved product, read from /products/<handle>.js (photo, name, price, "Añadir a la cesta" for
   single-variant products — adds it and opens the quick cart refreshed — or "Elegir opciones" to its page,
   "Eliminar"). Products that no longer exist are dropped from the list. */
(function () {
  if (window.__productWishlist) return;
  window.__productWishlist = true;

  var KEY = "liorme_wishlist";
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || "[]");
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* private mode: keep it in memory only */ }
  }

  var memory = null; // fallback when storage is unavailable
  function getList() { return memory || read(); }
  function setList(list) { memory = list; write(list); }

  function paint() {
    var list = getList();
    // only write what changed: rewriting identical attributes still costs style work on every card (2026-09-23)
    var set = function (el, name, value) { if (el.getAttribute(name) !== value) el.setAttribute(name, value); };
    document.querySelectorAll("[data-product-wishlist]").forEach(function (btn) {
      var on = list.indexOf(btn.dataset.handle) > -1;
      if (btn.classList.contains("is-active") !== on) btn.classList.toggle("is-active", on);
      set(btn, "aria-pressed", on ? "true" : "false");
      if (btn.dataset.labelAdd) set(btn, "aria-label", on ? btn.dataset.labelRemove : btn.dataset.labelAdd);
    });
    document.querySelectorAll("[data-js-wishlist-button]").forEach(function (btn) {
      if (btn.classList.contains("has-items") !== list.length > 0) btn.classList.toggle("has-items", list.length > 0);
      set(btn, "aria-label", list.length ? "Favoritos (" + list.length + ")" : "Favoritos");
    });
  }

  /* ---------- hearts ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-product-wishlist]");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var list = getList().slice();
    var i = list.indexOf(btn.dataset.handle);
    if (i > -1) list.splice(i, 1); else list.push(btn.dataset.handle);
    setList(list);
    paint();
    if (i === -1) {
      btn.classList.remove("is-popping");
      void btn.offsetWidth;
      btn.classList.add("is-popping");
    }
    if (drawerOpen()) renderDrawer();
  }, true);

  window.addEventListener("storage", function (e) { if (e.key === KEY) { memory = null; paint(); if (drawerOpen()) renderDrawer(); } });

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; paint(); });
  }).observe(document.body, { childList: true, subtree: true }); // body only: Shopify keeps adding <link> prefetches to <head> (~16/s), which re-ran this on every one (2026-09-23)
  paint();

  /* ---------- panel ---------- */
  var drawer = document.querySelector("[data-wishlist-drawer]");
  // lives in the header section, whose wrapper moves (auto-hide): out to <body> so position:fixed is the window
  if (drawer && drawer.parentNode !== document.body) document.body.appendChild(drawer);
  function drawerOpen() { return drawer && drawer.classList.contains("is-open"); }

  function money(cents) {
    var format = (drawer && drawer.dataset.moneyFormat) || "{{amount}}";
    var value = (cents / 100).toFixed(2);
    var parts = value.split(".");
    var intPart = parts[0];
    var withSep = function (sep, dec) {
      return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (dec === null ? "" : dec + parts[1]);
    };
    var out = format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      return {
        amount: withSep(",", "."),
        amount_no_decimals: withSep(",", null),
        amount_with_comma_separator: withSep(".", ","),
        amount_no_decimals_with_comma_separator: withSep(".", null),
        amount_with_apostrophe_separator: withSep("'", ".")
      }[k] || withSep(",", ".");
    });
    return out.replace(/[.,]00(?!\d)/, ""); // like the cards: "S/. 125"
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; });
  }

  function imgUrl(src, width) {
    if (!src) return "";
    return src + (src.indexOf("?") > -1 ? "&" : "?") + "width=" + width;
  }

  var cache = {};
  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(root + "products/" + encodeURIComponent(handle) + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) cache[handle] = p; return p; })
      .catch(function () { return undefined; }); // network error: keep the handle
  }

  function renderDrawer() {
    if (!drawer) return;
    var listEl = drawer.querySelector("[data-wishlist-list]");
    var emptyEl = drawer.querySelector("[data-wishlist-empty]");
    var countEl = drawer.querySelector("[data-wishlist-drawer-count]");
    var handles = getList();
    countEl.textContent = handles.length ? handles.length : "";
    if (!handles.length) {
      listEl.innerHTML = "";
      listEl.hidden = true;
      emptyEl.hidden = false;
      return;
    }
    emptyEl.hidden = true;
    listEl.hidden = false;
    Promise.all(handles.map(fetchProduct)).then(function (products) {
      var gone = handles.filter(function (h, i) { return products[i] === null; });
      if (gone.length) {
        setList(getList().filter(function (h) { return gone.indexOf(h) === -1; }));
        paint();
      }
      var rows = products.filter(Boolean).map(function (p) {
        var variant = p.variants.find(function (v) { return v.available; }) || p.variants[0];
        var single = p.variants.length === 1;
        var url = p.url || root + "products/" + p.handle;
        var img = p.featured_image ? '<img src="' + esc(imgUrl(p.featured_image, 360)) + '" alt="' + esc(p.title) + '" loading="lazy">' : "";
        var price = '<p class="wishlist-drawer__price">' + (p.price_varies ? "Desde " : "") + esc(money(p.price)) +
          (p.compare_at_price > p.price ? "<s>" + esc(money(p.compare_at_price)) + "</s>" : "") + "</p>";
        var action;
        if (!p.available) action = '<span class="wishlist-drawer__sold">Agotado</span>';
        else if (single) action = '<button type="button" class="wishlist-drawer__add" data-wishlist-add="' + variant.id + '">Añadir a la cesta</button>';
        else action = '<a class="wishlist-drawer__add" href="' + esc(url) + '">Elegir opciones</a>';
        return '<div class="wishlist-drawer__item">' +
          '<a class="wishlist-drawer__img" href="' + esc(url) + '" tabindex="-1">' + img + "</a>" +
          '<div class="wishlist-drawer__info">' +
            '<a class="wishlist-drawer__name" href="' + esc(url) + '">' + esc(p.title) + "</a>" + price +
            '<div class="wishlist-drawer__actions">' + action +
              '<button type="button" class="wishlist-drawer__remove" data-wishlist-remove="' + esc(p.handle) + '">Eliminar</button>' +
            "</div>" +
          "</div>" +
        "</div>";
      });
      listEl.innerHTML = rows.join("");
      countEl.textContent = getList().length || "";
      if (!rows.length) { listEl.hidden = true; emptyEl.hidden = false; }
    });
  }

  function openDrawer() {
    if (!drawer) return;
    renderDrawer();
    drawer.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { drawer.classList.add("is-open"); }); });
    document.body.classList.add("wishlist-drawer-open");
    var close = drawer.querySelector(".wishlist-drawer__close");
    setTimeout(function () { close && close.focus(); }, 50);
  }
  function closeDrawer() {
    if (!drawerOpen()) return;
    drawer.classList.remove("is-open");
    document.body.classList.remove("wishlist-drawer-open");
    setTimeout(function () { if (!drawerOpen()) drawer.hidden = true; }, 450);
  }

  document.addEventListener("click", function (e) {
    var headerHeart = e.target.closest("[data-js-wishlist-button]");
    if (headerHeart) { e.preventDefault(); openDrawer(); return; }
    if (!drawer || !drawer.contains(e.target)) return;
    if (e.target.closest("[data-wishlist-close]")) { closeDrawer(); return; }
    var rm = e.target.closest("[data-wishlist-remove]");
    if (rm) {
      setList(getList().filter(function (h) { return h !== rm.dataset.wishlistRemove; }));
      paint();
      renderDrawer();
      return;
    }
    var add = e.target.closest("[data-wishlist-add]");
    if (add) addToCart(add);
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });

  /* add a single-variant product, refresh Stiletto's quick cart and open it (falls back to the cart page) */
  function addToCart(btn) {
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = "Añadiendo…";
    fetch(root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: +btn.dataset.wishlistAdd, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || "Error"); return j; }); })
      .then(function () {
        var quick = document.querySelector(".quick-cart");
        var section = quick && quick.closest(".shopify-section");
        if (!quick || !section) { location.href = root + "cart"; return; }
        return fetch(root + "cart?section_id=" + section.id.replace("shopify-section-", ""))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var fresh = new DOMParser().parseFromString(html, "text/html").querySelector(".quick-cart__container");
            var current = quick.querySelector(".quick-cart__container");
            if (fresh && current) current.innerHTML = fresh.innerHTML;
            document.dispatchEvent(new CustomEvent("apps:product-added-to-cart"));
            closeDrawer();
            var cartIcon = document.querySelector("header [data-js-cart-icon]");
            setTimeout(function () { cartIcon && cartIcon.click(); }, 300);
          });
      })
      .catch(function (err) {
        btn.textContent = err.message;
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2500);
        return;
      })
      .then(function () { if (btn.textContent === "Añadiendo…") { btn.textContent = label; btn.disabled = false; } });
  }
})();
